// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Hip4","question":"Question_question__1-FK5","description":"Question_description__3FRjp"};